export var getStampS = function getStampS() {
  return Math.floor(getStampMs() / 1000);
};
export var getStampMs = function getStampMs() {
  return new Date().getTime();
};
export var getYear = function getYear() {
  return new Date().getFullYear();
};